export const SUGGESTIONS  = {
  General: [
    "What’s the market outlook for renewable energy companies in 2025?",
    "Compare the efficiency of Zoom and Microsoft Teams for remote work.",
    "How has Satya Nadella influenced Microsoft’s cloud strategy?",
    "What’s the adoption trend for AI in healthcare by 2028?",
    "What products does Google offer in its cloud division?",
    "How does Netflix’s content strategy impact its revenue?",
    "Who are the key customers of SAP’s ERP solutions?",
    "What’s the future of electric vehicle technology by 2030?",
    "Analyze Amazon’s logistics performance in 2024.",
    "What trends are shaping the cybersecurity industry this year?"
  ],
  RecommendedSoftware: [
    "What software should a small business use for customer relationship management in 2025?",
    "Which tools are recommended for project management in remote teams?",
    "What’s the best software for data analytics in the retail industry?",
    "Recommend software for improving supply chain efficiency in manufacturing.",
    "What tools should a marketing team use for campaign tracking next year?",
    "Which software is ideal for financial forecasting for startups?",
    "What’s the top recommended software for video conferencing in large enterprises?",
    "Recommend software for automating HR processes in mid-sized companies.",
    "What tools are best for cybersecurity in the healthcare sector?",
    "Which software should an e-commerce business use for inventory management?",
  ],
  BenchmarkCompanies: [
    "How does Apple’s financial performance in 2025 compare to Samsung’s?",
    "What are the key products driving Amazon’s revenue growth this year?",
    "Benchmark Tesla’s market share against Toyota in the electric vehicle sector for 2026.",
    "How does Google’s cloud division performance stack up against Microsoft Azure?",
    "What trends define the top-performing companies in the renewable energy sector in 2025?",
    "Compare the operational efficiency of Walmart and Target based on their latest data.",
    "How does Netflix benchmark against Disney+ in subscriber growth and content investment?",
    "What sets the leading financial institutions apart in sustainability metrics for 2025?",
    "Benchmark the customer satisfaction scores of Salesforce and HubSpot this year.",
    "How do the R&D investments of Pfizer and Moderna compare in the pharmaceutical industry?",
  ],
  AnalyzeTechStacksForCompanies: [
    "Analyze the software products offered by Adobe as of March 2025.",
    "What software products does Salesforce currently provide based on their official sources?",
    "Identify the software products of Microsoft using their latest job postings and website data.",
    "Conduct an analysis of Oracle’s software products with evidence from primary and secondary sources.",
    "What are the software products of SAP based on their 2025 updates?",
    "List the software products offered by Zoom, focusing on data from their website and social media.",
    "Analyze IBM’s software products using LinkedIn profiles and industry reports.",
    "What software does HubSpot offer according to their official website and X posts?",
    "Identify the software products of Autodesk with a focus on 2024-2025 trends.",
    "Conduct a comprehensive analysis of software products from ServiceNow using all available sources."
  ],
  FindCustomersOfProducts:[
    "Analyze companies using Salesforce for customer relationship management as of March 2025.",
    "Identify organizations leveraging Microsoft Azure for cloud computing solutions.",
    "List companies adopting SAP ERP for enterprise resource planning in 2025.",
    "Conduct an analysis of firms using Adobe Creative Cloud for design and media production.",
    "What organizations are utilizing Zoom for video conferencing and collaboration?",
    "Benchmark companies implementing Oracle NetSuite for financial management.",
    "Analyze the use of ServiceNow by companies for IT service management.",
    "Identify businesses using HubSpot for marketing automation and CRM.",
    "List companies that rely on Autodesk software for design and engineering tasks.",
    "Conduct a comprehensive analysis of organizations using Slack for team communication."
  ]
}